export default __webpack_public_path__ + "static/media/logotipo-do-github.d1bb13ce.svg";